import { useLocalStore } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

export default ({ common, focus }) => {
  const presenter = useLocalStore(() => ({
    get inputPanel() {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    onEnter: (event) => {
      event.stopPropagation();
      event.preventDefault();

      const command = common.commands[focus.focusedIndex];

      presenter.send(command);
    },

    send: ({ command }) => {
      Tasks.messaging.createNewMessages(common.group.id, [
        {
          payload: new TextPayload({ text: command }),
        },
      ]);

      presenter.inputPanel.bots.hideCommandList();
    },
  }));

  return presenter;
};
